import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { COLORS } from '@hcr/ui'

import { NavigationAccountButtonWrapper } from '../navigation-account-button-wrapper'

const ButtonColors = {
  STANDARD: COLORS.linknega[500],
  HOVER: COLORS.linknega['80%'],
  PRESSED: COLORS.linknega['60%'],
} as const

interface NavigationAccountButtonProps {
  firstName: string
  isVisible: boolean
  lastName: string
  setIsVisible: (isVisible: boolean) => void
}

export const NavigationAccountButton: FC<NavigationAccountButtonProps> = ({
  firstName,
  lastName,
  setIsVisible,
  isVisible,
}) => {
  const { t } = useTranslation()

  const screenReaderPhase = `${t('navigation.logged-in')} ${firstName} ${lastName}`

  return (
    <NavigationAccountButtonWrapper
      hoverColor={ButtonColors.HOVER}
      isVisible={isVisible}
      pressedColor={ButtonColors.PRESSED}
      screenReaderPhase={screenReaderPhase}
      setIsVisible={setIsVisible}
      standardColor={ButtonColors.STANDARD}
    >
      <span className='desktop-text' aria-hidden={true}>
        {`${firstName} ${lastName[0]}.`}
      </span>
      <span className='mobile-text' aria-hidden={true}>
        {`${firstName[0]}${lastName[0]}`}
      </span>
    </NavigationAccountButtonWrapper>
  )
}
